import React from 'react'
import CountUp from 'react-countup'
import about_1 from '../../../assets/images/about/about-two-1.jpg'
import about_2 from '../../../assets/images/svg/Star-two1.svg'
import about_3 from '../../../assets/images/svg/counter-1.svg'
import about_4 from '../../../assets/images/about/about-two-2.jpg'


const About = () => {
    return (
        <>
            <div className="about-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div
                                className="about-image-left-two animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <img src={about_1} alt="about-image" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-right-two">
                                <div className="heading-box light">
                                    <span
                                        className="sub-title animate fadeInUp wow"
                                        data-wow-duration="2000ms"
                                    >
                                        Services
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="2000ms"
                                        data-wow-delay="200ms"
                                    >
                                        We are building great future together Be with us
                                    </h2>
                                </div>
                                <div
                                    className="about-details-two animate fadeInUp wow"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="400ms"
                                >
                                    <p className="lead">
                                        Crafting engaging websites to implementing powerful digital
                                        marketing strategies, we focus on understanding your unique needs
                                        and goals. Our dedication to your success means we’re always
                                        innovating to ensure stay ahead in digital landscape
                                    </p>
                                    <div className="about-list-two">
                                        <div className="about-list-inner-two">
                                            <div>
                                                <img src={about_2} alt="icon" />
                                                <h4>Digital Innovation</h4>
                                            </div>
                                            <p>
                                                We stay up-to-date with the latest technology trends and offer
                                            </p>
                                        </div>
                                        <div className="about-list-inner-two">
                                            <div>
                                                <img src={about_2} alt="icon" />
                                                <h4>Cost-Effectiveness</h4>
                                            </div>
                                            <p>We guarantee to provide affordable business consulting</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div
                                className="about-counter-two animate fadeInUp wow"
                                data-wow-duration="2000ms"
                            >
                                <div className="about-counter-icon-two">
                                    <img src={about_3} alt="icon" />
                                </div>
                                <h4>
                                    <span><CountUp end={1962} duration={3} /></span>
                                    <span>+</span>
                                </h4>
                                <p>Project Completed</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div
                                className="about-image-right-two animate fadeInRight wow"
                                data-wow-duration="2000ms"
                            >
                                <img src={about_4} alt="about-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default About
